// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"3e64570d","196":"f0e3630d","379":"a58323d6","461":"d919b437","596":"62e6c194","719":"8e10723a","983":"467bf0ba"}[chunkId] + ".chunk.js";
};